var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decline-reasons"},[(_vm.declineReasons.length)?_c('v-col',[_c('span',[_vm._v(" Decline Reasons ")]),_c('ul',_vm._l((_vm.declineReasons),function(declineReason){return _c('li',{key:declineReason.index},[_vm._v(" "+_vm._s(declineReason)+" ")])}),0)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }